import { actaApi } from '../services/actaApi';

export function getRelativeFileUrl(url?: string): string {
  if (!url) {
    return '';
  }
  // Se o backend já retornar um "http://..." completo, não precisa concatenar
  if (url.startsWith('http://') || url.startsWith('https://')) {
    return url;
  }
  // Caso contrário, concatena com a baseURL
  return `${actaApi.defaults.baseURL}${url}`;
}
